"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionRing = exports.getClosestSelectionRing = exports.useSelectionRingContext = void 0;
var react_1 = __importStar(require("react"));
var useSelectionState_1 = require("./useSelectionState");
var styles = __importStar(require("./SelectionRing.css"));
var slate_1 = require("slate");
var EditorWidgetRegistry_1 = require("../WidgetRegistry/EditorWidgetRegistry");
var Resizer_1 = require("./Resizer");
var SyntheticSelection_1 = require("Project/SyntheticSelection");
var slate_react_1 = require("slate-react");
var inversify_react_1 = require("inversify-react");
var Router_1 = __importDefault(require("../Router"));
var EditorTypes_1 = require("../EditorTypes");
var ReactUtils_1 = require("@CommonFrontend/Utils/ReactUtils");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var DragHandle_1 = require("./DragHandle");
var DragStore_1 = require("Project/Stores/DragStore/DragStore");
var lodash_1 = require("lodash");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var DragContext_1 = require("./DragContext");
var GetTraitConfig_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetTraitConfig");
var dynamic_1 = require("@vanilla-extract/dynamic");
var mobx_react_1 = require("mobx-react");
var SlateSelectionStore_1 = require("../SlateSelectionStore");
var Telemetry_1 = require("@CommonFrontend/Telemetry");
var EditorConfigurationContext_1 = require("./EditorConfigurationContext");
var DragPreviewImageHost_1 = require("../DragPreviewImageHost");
var observe_rect_1 = __importDefault(require("@reach/observe-rect"));
var selectionRingContext = (0, react_1.createContext)(null);
var SelectionRingContextProvider = selectionRingContext.Provider;
var useSelectionRingContext = function () {
    var context = (0, react_1.useContext)(selectionRingContext);
    if (!context) {
        throw new Error("useSelectionRingContext must be used with SelectionRingContextProvider");
    }
    return context;
};
exports.useSelectionRingContext = useSelectionRingContext;
var getClosestSelectionRing = function (target, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.mode, mode = _c === void 0 ? "over-selectable-region" : _c;
    var bubbleRootSelector = ["[".concat(styles.ringDataAttribute, "]"), styles.childSelector];
    if (mode === "over-selectable-region") {
        bubbleRootSelector.push(styles.interactiveElementSelector, styles.textElementSelector);
    }
    var bubbleRoot = target.closest(bubbleRootSelector.join(","));
    if (!bubbleRoot) {
        return null;
    }
    if (!bubbleRoot.getAttribute(styles.ringDataAttribute)) {
        return null;
    }
    return bubbleRoot;
};
exports.getClosestSelectionRing = getClosestSelectionRing;
exports.SelectionRing = (0, mobx_react_1.observer)((0, react_1.forwardRef)(function (_a, ref) {
    var _b, _c, _d;
    var _e, _f;
    var element = _a.element, children = _a.children;
    var slate = (0, slate_react_1.useSlate)();
    var editor = (0, inversify_react_1.useInjection)(EditorTypes_1.SlateEditor.$);
    var router = (0, inversify_react_1.useInjection)(Router_1.default);
    var componentId = (0, react_1.useRef)((0, lodash_1.uniqueId)());
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var conversionElem = (0, inversify_react_1.useInjection)("conversionElem");
    var dragStore = (0, inversify_react_1.useInjection)("dragStore");
    var dropLocationStore = (0, inversify_react_1.useInjection)("dropLocationStore");
    var widgetAdderStore = (0, inversify_react_1.useInjection)("widgetAdderStore");
    var slateSelectionStore = (0, inversify_react_1.useInjection)(SlateSelectionStore_1.SlateSelectionStore);
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var telemetry = (0, inversify_react_1.useInjection)("telemetry");
    var user = (0, inversify_react_1.useInjection)("user");
    var account = (0, inversify_react_1.useInjection)("account");
    var dragImagePreviewHost = (0, inversify_react_1.useInjection)(DragPreviewImageHost_1.DragImagePreviewHostElement.$);
    var allowWidgetDragAndDrop = (0, DragContext_1.useDragContext)().allowWidgetDragAndDrop;
    var widgetSelectionState = (0, useSelectionState_1.useSelectionState)(element).widgetSelectionState;
    var selectionStoreActions = (0, SyntheticSelection_1.useSelectionStoreActions)();
    var selectionBoxStore = (0, inversify_react_1.useInjection)("selectionBoxStore");
    var enableAdditionalSlopAtBlockBoundaries = (0, EditorConfigurationContext_1.useEditorConfigurationContext)().enableAdditionalSlopAtBlockBoundaries;
    var currentPath = slate_react_1.ReactEditor.findPath(slate, element);
    var lastChildPath = [editor.children.length - 1];
    var isFirstWidgetInBlock = (0, lodash_1.isEqual)(currentPath, [0]);
    var isLastWidgetInBlock = (0, lodash_1.isEqual)(currentPath, lastChildPath);
    var currentItemIsBeingDragged = dragStore.widgetIsBeingDragged(editor, currentPath);
    var isQuoteBlock = blockStore.blockType === "QuoteV2";
    var _g = __read((0, react_1.useState)(false), 2), isMouseOverWidgetIncludingChildren = _g[0], setIsMouseOverWidgetIncludingChildren = _g[1];
    var _h = __read((0, react_1.useState)(false), 2), isMouseOverWidgetExcludingChildren = _h[0], setIsMouseOverWidgetExcludingChildren = _h[1];
    var _j = __read((0, react_1.useState)(false), 2), isMouseOverSelectableRegion = _j[0], setIsMouseOverSelectableRegion = _j[1];
    var _k = __read((0, react_1.useState)(false), 2), isMouseDownOnSelectableRegion = _k[0], setIsMouseDownOnSelectableRegion = _k[1];
    var ringRef = (0, react_1.useRef)(null);
    var ringBorderRef = (0, react_1.useRef)(null);
    var resizerContext = (0, Resizer_1.useResizerContext)();
    var elementConfiguration = (0, EditorWidgetRegistry_1.getGenericConfigByType)(element.type, true);
    var selectionTraitConfig = (0, GetTraitConfig_1.getTraitConfig)({ widgetType: element.type, traitName: "selection" });
    var mode = (_e = selectionTraitConfig === null || selectionTraitConfig === void 0 ? void 0 : selectionTraitConfig.ringMode) !== null && _e !== void 0 ? _e : (resizerContext.resizingEnabled && resizerContext.handleDirections === "corners" ? "hugging" : "outside");
    var elementIsInline = (0, EditorWidgetRegistry_1.isInlineWidget)(element);
    var draggable = usingFeature(FeatureFlag_1.default.ErgonomicsDragging) && !elementIsInline;
    var showDragHandle = isMouseOverWidgetExcludingChildren ||
        (isMouseOverWidgetIncludingChildren && (elementConfiguration === null || elementConfiguration === void 0 ? void 0 : elementConfiguration.nodeType) === "textElement");
    var _l = __read((0, react_1.useState)(null), 2), customRingColor = _l[0], setCustomRingColor = _l[1];
    var selectionEntry = (0, react_1.useMemo)(function () {
        return {
            editor: editor,
            conversionElem: conversionElem,
            router: router,
            path: currentPath,
        };
    }, [conversionElem, editor, router, currentPath]);
    var _m = __read((0, react_1.useState)(null), 2), currentBoundingBox = _m[0], setCurrentBoundingBox = _m[1];
    (0, react_1.useEffect)(function () {
        selectionBoxStore.register({
            id: componentId.current,
            selectionEntry: selectionEntry,
        });
        if (currentBoundingBox) {
            selectionBoxStore.updateRect(componentId.current, currentBoundingBox);
        }
        var componentIdValue = componentId.current;
        return function () {
            selectionBoxStore.remove(componentIdValue);
        };
    }, [selectionBoxStore, selectionEntry, usingFeature, currentBoundingBox]);
    (0, react_1.useEffect)(function () {
        var rectObserver = (0, observe_rect_1.default)(ringBorderRef.current, function (rect) {
            setCurrentBoundingBox(rect);
            selectionBoxStore.updateRect(componentId.current, rect);
        });
        rectObserver.observe();
        return function () {
            rectObserver.unobserve();
        };
    }, [selectionBoxStore, componentId, usingFeature]);
    (0, react_1.useEffect)(function () {
        if (!isMouseDownOnSelectableRegion)
            return;
        var mouseUpHandler = function () {
            setIsMouseDownOnSelectableRegion(false);
        };
        document.addEventListener("mouseup", mouseUpHandler);
        return function () {
            document.removeEventListener("mouseup", mouseUpHandler);
        };
    }, [isMouseDownOnSelectableRegion]);
    var showingWidgetAdder = slateSelectionStore.focussed &&
        !!widgetAdderStore.currentPath &&
        slate_1.Path.equals(currentPath, widgetAdderStore.currentPath);
    return (react_1.default.createElement("div", __assign((_b = {}, _b[styles.ringDataAttribute] = true, _b.ref = (0, ReactUtils_1.composeRefs)([ref, ringRef]), _b.className = styles.wrapper({
        widgetWidth: elementConfiguration === null || elementConfiguration === void 0 ? void 0 : elementConfiguration.width,
        extraSpaceBeforeFirstWidgetInBlock: enableAdditionalSlopAtBlockBoundaries &&
            isFirstWidgetInBlock &&
            dragStore.isDragging &&
            !currentItemIsBeingDragged &&
            !isQuoteBlock,
        extraSpaceAfterLastWidgetInBlock: enableAdditionalSlopAtBlockBoundaries &&
            isLastWidgetInBlock &&
            dragStore.isDragging &&
            !currentItemIsBeingDragged &&
            !isQuoteBlock,
        isInline: elementIsInline,
    }), _b.style = (0, dynamic_1.assignInlineVars)((_c = {}, _c[styles.customRingColor] = customRingColor !== null && customRingColor !== void 0 ? customRingColor : "unset", _c)), _b.onClick = function (e) {
        if ((0, SyntheticSelection_1.lastMouseClickChangedTargetBetweenDownAndUp)()) {
            return;
        }
        if ((0, exports.getClosestSelectionRing)(e.target) !== ringRef.current) {
            return;
        }
        if (draggable && (e.shiftKey || e.ctrlKey || e.metaKey)) {
            selectionStoreActions.toggleSelection([selectionEntry]);
            if ((elementConfiguration === null || elementConfiguration === void 0 ? void 0 : elementConfiguration.nodeType) === "textElement" && e.target === ringBorderRef.current) {
                setIsMouseOverSelectableRegion(false);
            }
        }
        else {
            selectionStoreActions.setSelection([selectionEntry]);
        }
        slate_react_1.ReactEditor.deselect(slate);
        slate_react_1.ReactEditor.blur(slate);
    }, _b.onMouseOver = function (e) {
        setIsMouseOverWidgetIncludingChildren(true);
        if ((0, exports.getClosestSelectionRing)(e.target, { mode: "over-widget-exluding-children" }) === ringRef.current) {
            setIsMouseOverWidgetExcludingChildren(true);
        }
        if ((0, exports.getClosestSelectionRing)(e.target) === ringRef.current) {
            setIsMouseOverSelectableRegion(true);
        }
    }, _b.onMouseOut = function () {
        setIsMouseOverWidgetIncludingChildren(false);
        setIsMouseOverWidgetExcludingChildren(false);
        setIsMouseOverSelectableRegion(false);
    }, _b.onDragOver = function () {
        setIsMouseOverWidgetIncludingChildren(true);
    }, _b.onDragLeave = function () {
        setIsMouseOverWidgetIncludingChildren(false);
    }, _b), (draggable
        ? {
            draggable: isMouseDownOnSelectableRegion,
            onDragStart: function (event) {
                if (!isMouseDownOnSelectableRegion)
                    return;
                event.stopPropagation();
                var itemsToDrag = selectionStoreActions.getSelection();
                if (!["circle", "multi"].includes(widgetSelectionState)) {
                    itemsToDrag = [selectionEntry];
                    selectionStoreActions.setSelection(itemsToDrag);
                    slate_react_1.ReactEditor.deselect(slate);
                    slate_react_1.ReactEditor.blur(editor);
                }
                if (dragImagePreviewHost.current) {
                    var orderedSelection = itemsToDrag.sort(function (a, b) { return slate_1.Path.compare(a.path, b.path); });
                    var path_1 = slate_react_1.ReactEditor.findPath(editor, element);
                    var focalElementIndex = orderedSelection.findIndex(function (selection) {
                        return slate_1.Path.equals(path_1, selection.path);
                    });
                    var _a = (0, DragPreviewImageHost_1.populatePreviewImage)({
                        hostElement: dragImagePreviewHost.current,
                        selection: orderedSelection,
                        focalElementIndex: focalElementIndex,
                    }), offsetLeft = _a.offsetLeft, offsetTop = _a.offsetTop;
                    event.dataTransfer.setDragImage(dragImagePreviewHost.current, offsetLeft, offsetTop);
                }
                var dragItemsFromSelectionStore = itemsToDrag.map(function (selection) {
                    var node = slate_1.Node.get(selection.editor, selection.path);
                    (0, tiny_invariant_1.default)(slate_1.Element.isElement(node), "Only elements can be dragged");
                    return {
                        sourcePath: selection.path,
                        sourceNode: (0, lodash_1.cloneDeep)(node),
                        sourceEditor: editor,
                        type: DragStore_1.DragType.Widget,
                    };
                });
                dragStore.startDrag(dragItemsFromSelectionStore);
                telemetry.identify(user, account, { drag_handle_used: true });
                telemetry.trackOnly(Telemetry_1.TelemetryEventName.DragHandleUsed, {
                    method: "dragged",
                    inline_content_type: element.type,
                    number_of_dragged_widgets: dragItemsFromSelectionStore.length,
                });
            },
            onDragEnd: function () {
                setIsMouseDownOnSelectableRegion(false);
                dragStore.stopDrag();
                dropLocationStore.clearDropLocation();
                if (dragImagePreviewHost.current) {
                    (0, DragPreviewImageHost_1.clearPreviewImageHost)(dragImagePreviewHost.current);
                }
            },
        }
        : {}), { onMouseDown: function (e) {
            var selectionRing = (0, exports.getClosestSelectionRing)(e.target);
            if (selectionRing === ringRef.current) {
                setIsMouseDownOnSelectableRegion(true);
            }
        } }),
        react_1.default.createElement("div", { ref: ringBorderRef, "data-testid": "selection-ring", style: (0, dynamic_1.assignInlineVars)((_d = {},
                _d[styles.customRingBorderRadius] = (selectionTraitConfig === null || selectionTraitConfig === void 0 ? void 0 : selectionTraitConfig.ringBorderRadius)
                    ? "".concat(selectionTraitConfig.ringBorderRadius, "px")
                    : "unset",
                _d)), className: styles.ring({
                mouseOverWidget: (selectionTraitConfig === null || selectionTraitConfig === void 0 ? void 0 : selectionTraitConfig.showWidgetOutlineOnHover) && isMouseOverWidgetIncludingChildren,
                mouseOverSelectableRegion: isMouseOverSelectableRegion,
                selected: ["circle", "around", "multi"].includes(widgetSelectionState) ||
                    (resizerContext.resizingEnabled && resizerContext.isResizing),
                nodeType: elementConfiguration === null || elementConfiguration === void 0 ? void 0 : elementConfiguration.nodeType,
                mode: mode,
                isInline: elementIsInline,
            }), contentEditable: false }, resizerContext.resizingEnabled && (react_1.default.createElement(Resizer_1.ResizeHandles, { show: isMouseOverSelectableRegion || widgetSelectionState === "circle", element: element }))),
        draggable && allowWidgetDragAndDrop && !showingWidgetAdder && (react_1.default.createElement("div", { contentEditable: false },
            react_1.default.createElement(DragHandle_1.DragHandle, { show: showDragHandle, className: styles.dragHandle({
                    alignment: (_f = selectionTraitConfig === null || selectionTraitConfig === void 0 ? void 0 : selectionTraitConfig.dragHandleTop) !== null && _f !== void 0 ? _f : "widget",
                    mode: mode,
                    nodeType: elementConfiguration === null || elementConfiguration === void 0 ? void 0 : elementConfiguration.nodeType,
                }), element: element }))),
        react_1.default.createElement(SelectionRingContextProvider, { value: {
                mouseOverWidget: (selectionTraitConfig === null || selectionTraitConfig === void 0 ? void 0 : selectionTraitConfig.showWidgetOutlineOnHover)
                    ? isMouseOverWidgetIncludingChildren
                    : false,
                mouseOverSelectableRegion: isMouseOverSelectableRegion,
                setCustomRingColor: setCustomRingColor,
            } }, children)));
}));
exports.SelectionRing.displayName = "SelectionRing";
